var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRrCrossSmall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-cross-small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 5.99997C17.8124 5.8125 17.5581 5.70718 17.293 5.70718C17.0278 5.70718 16.7735 5.8125 16.586 5.99997L12 10.586L7.41397 5.99997C7.22644 5.8125 6.97213 5.70718 6.70697 5.70718C6.44181 5.70718 6.1875 5.8125 5.99997 5.99997C5.8125 6.1875 5.70718 6.44181 5.70718 6.70697C5.70718 6.97213 5.8125 7.22644 5.99997 7.41397L10.586 12L5.99997 16.586C5.8125 16.7735 5.70718 17.0278 5.70718 17.293C5.70718 17.5581 5.8125 17.8124 5.99997 18C6.1875 18.1874 6.44181 18.2928 6.70697 18.2928C6.97213 18.2928 7.22644 18.1874 7.41397 18L12 13.414L16.586 18C16.7735 18.1874 17.0278 18.2928 17.293 18.2928C17.5581 18.2928 17.8124 18.1874 18 18C18.1874 17.8124 18.2928 17.5581 18.2928 17.293C18.2928 17.0278 18.1874 16.7735 18 16.586L13.414 12L18 7.41397C18.1874 7.22644 18.2928 6.97213 18.2928 6.70697C18.2928 6.44181 18.1874 6.1875 18 5.99997Z",
    fill: "#374957"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCrossSmall2);
export default __webpack_public_path__ + "static/media/fi-rr-cross-small (2).987374123be296fdb9cd45e91647fec5.svg";
export { ForwardRef as ReactComponent };